import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

/**
 * A booking's day and run as Review and book draws it (SF 74): "Wed 14 Oct ·
 * 9:30 – 11:45 am", with am or pm once when the run stays in one half of the
 * day and on both ends when it crosses noon ("11:30 am – 1:45 pm"). The slot
 * is the salon's wall-clock time ("9:30 AM" on "2026-10-14"), so nothing here
 * reads the device's zone.
 */
export const whenRange = (day: string, time: string, minutes: number): string => {
  const start = dayjs(`${day} ${time}`, 'YYYY-MM-DD h:mm A', true);
  if (!start.isValid()) return '';
  const dayLabel = start.format('ddd D MMM');
  if (!(minutes > 0)) return `${dayLabel} · ${start.format('h:mm a')}`;
  const end = start.add(minutes, 'minute');
  const oneHalf = start.isSame(end, 'day') && start.format('a') === end.format('a');
  return oneHalf
    ? `${dayLabel} · ${start.format('h:mm')} – ${end.format('h:mm a')}`
    : `${dayLabel} · ${start.format('h:mm a')} – ${end.format('h:mm a')}`;
};
